import { render, staticRenderFns } from "./sopTable.vue?vue&type=template&id=056a2673&"
import script from "./sopTable.vue?vue&type=script&lang=js&"
export * from "./sopTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports